import { Col, Row, Button, Modal } from "react-bootstrap";

const CaseFileDetails = ({ data, cms, state }) => {
  const { CaseFileDetails } = data;
  return (
    <div className="left_side_widget mb30 tour-pdp-details p0">
      <Row className="propertyInfoBoxHeading p0">
        <h3 className='propertyInfoBoxHeadingText' >
          Case File Details
        </h3>
      </Row>
      <div className="mt10 ml25">
        <div className="row ">
          <div className="fc-row-label">
            Attorney/Trustee Name{" "}
          </div>
          <div className="fc-row-value pdpTextBlack">
            {data?.trusteename || data?.trustName}
          </div>
        </div>
        <div className="row ">
          <div className="fc-row-label">
            Phone Number{" "}
          </div>
          <div className="fc-row-value pdpTextBlack wa">
            {data?.phoneNumber}
          </div>

        </div>
        <div className="row ">
          <div className="fc-row-label">
            Case File Number{" "}
          </div>
          <div className="fc-row-value pdpTextBlack wa">
            {data?.caseFileNumber}
          </div>
        </div>
        {
          data?.trusteeAddress && 
         <div className="row ">
          <div className="fc-row-label">
            Trustee Address{" "}
          </div>
          <div className="fc-row-value pdpTextBlack wa">
            {data?.trusteeAddress}
          </div>
        </div>
        }
      </div>
      

    </div>
  );
};

export default CaseFileDetails;
